import { createContext } from 'react'

export interface NotificationsContextValue {
  disableNotificationsAsync: () => Promise<void>
  enableNotificationsAsync: () => Promise<boolean>
  isDisablingNotifications: boolean
  isEnablingNotifications: boolean
  setBadgeCountAsync: (count: number) => Promise<void>
}

export const NotificationsContext = createContext<NotificationsContextValue>({
  disableNotificationsAsync: () => Promise.resolve(),
  enableNotificationsAsync: () => Promise.resolve(false),
  isDisablingNotifications: false,
  isEnablingNotifications: false,
  setBadgeCountAsync: () => Promise.resolve()
})
